import React from 'react';
import {
    useHistory
  } from "react-router-dom";
  
  function Checkout(props)  {

    
    const data = 
      {
      "id": 1,
      "name": "Favorite BBQ",
      "street": "123 Main St.",
      "city": "Sandy Springs",
      "state": "Georgia",
      "badges": 
      [        
        {
            "id": 1,
            "name": "I love Favorite BBQ",
            "price": 5,
            "logo": "badge1.png",
            "selected": false
        },
        {
            "id": 2,
            "name": "Can't wait to get back to Favorite BBQ",
            "price": 5,
            "logo": "badge2.png",
            "selected": false
        },
        {
            "id": 3,
            "name": "Favorite BBQ Super Fan!",
            "price": 20,
            "logo": "badge3.png",
            "selected": false
        },

      ]
    }
    ;

    let history = useHistory();

    function paid()
    {
      history.push("/thankyou");
    }

    const selection =data.badges;
    
    const list = props.list;

    return <div className="App container">
            <div class="row">
                <div class="col-8">{data.name} of {data.city}, {data.state}</div>
            </div>
            <div class="row">
                <hr/>
            </div>
            <div class="row">
                <SelectionList data={list} paid={paid} merchant={data.name} />
            </div>
        </div>
    ;
  }

  function SelectionList(props)
  {

      const selection = props.data;
      const paid = props.paid;

      const selected = selection.filter(item => item.selected === true);

      var total = 0;

      selected.map(item => (total = total + item.price));

      return (
        <div className="container">
            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                            <ol>
                            {
                                selected                   
                                    .map(item => (                    
                                    (
                                        <li key={item}>{item.name} {item.selected ? 'true': 'false'}</li>
                                    )
                                ))
                            }
                            </ol>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">Your order: {selected.length } badge(s), ${total} total </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <form onSubmit={paid}>
                        <div className="container">
                            <div className="row"><div className="col"><label className="d-none d-sm-block" for='name'>Your name&nbsp;</label><input className="form-control" type='text' placeholder="First Last" name='name' id='name' required></input></div></div>
                            <div className="row"><div className="col"><label className="d-none d-sm-block" for='email'>Your email</label><input className="form-control" type='email' placeholder="email@locally.gives" name='email' id='email' required></input></div></div>
                            <div className="row"><div className="col"><label for="optin"><input type='checkbox' name='optin' id='optin'></input>&nbsp; I would like to receive updates from locally.gives</label></div></div>
                            <div className="row"><div className="col"><label for="optinmerchant"><input type='checkbox' name='optinmerchant' id='optinmerchant'></input>&nbsp;Please share my email with {props.merchant}</label></div></div>
                            <div className="row">
                                { selected.length > 0 &&
                                <div className="col" >Pay with Paypal <input type="image" src="/go-button.png" onClick="form.submit()"/> </div>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
      );
  }

 
  export default Checkout;


